import axios from "api/axiosController";

const similarProductsParentRoute = "/similar-products";

export default async function fetchSimilarProducts({
  sellerId,
  categoryFilter,
}: {
  sellerId: string | null;
  categoryFilter: any;
}) {
  const response = await axios.post(
    `${similarProductsParentRoute}/get-products`,
    {
      sellerId,
      categoryFilter,
    }
  );
  console.log("Similar Products Response:", response.data);
  return response.data;
}
